module.exports = __webpack_public_path__ + "img/257.44986c75.jpg";